import classNames from "classnames";
import { Children, cloneElement, PropsWithChildren, ReactElement, useRef } from "react";
import { Transition } from "react-transition-group";
import styles from "./animation.module.scss";

interface AnimateProps {
  when: boolean;
  appear?: boolean;
  animation: string;
  duration?: number;
  delay?: number;
  timeout?: { appear?: number, enter?: number, exit?: number } | 0;
  unmountOnExit?: boolean;
  onEntered?: () => void;
  onExited?: (e: any) => void;
  noTransition?: boolean
  transitionProperty?: string;
}

export function Animate(props: PropsWithChildren<AnimateProps>) {
  const { when, appear = true, children, animation, duration = 500, delay = 0, timeout = 0, unmountOnExit, onEntered, noTransition, transitionProperty, onExited } = props;
  const child = getChild(children);
  const nodeRef = useRef(null);
  
  const style:React.StyleHTMLAttributes<any> = noTransition ? {} :{
    ...(child as ReactElement).props.style,  
    transition: `${transitionProperty || "all"} ease`,
    transitionDuration: `${duration}ms`,
    transitionDelay: `${delay}ms`
  };
  
  return (
    <Transition onExited={onExited} nodeRef={nodeRef} in={when} appear={appear} timeout={timeout} unmountOnExit={unmountOnExit} onEntered={onEntered}>
      {state => {
        const className = classNames((child as JSX.Element)?.props.className, styles[animation], styles[`state-${state}`]);
        return cloneElement((child as JSX.Element), { className, style, ref: nodeRef });
      }}
    </Transition>
  );
}

function getChild(children:React.ReactNode):React.ReactNode {
  if (children instanceof Array) return <div>{children}</div>;
    else if (children instanceof Object) {
      const child = Children.only(children);
      return (typeof (child as JSX.Element).type == 'string') ? child : <div>{child}</div>;
    }
}